import { notify } from "@src/app/components/notify"

export const copy = (t: string) =>
  navigator.clipboard.writeText(t).then(() => notify.success("Copied"))
